import { createReducer } from "@reduxjs/toolkit";
import {
  INDUSTRIES_ERROR,
  INDUSTRIES_LIST,
  INDUSTRIES_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const industriesReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(INDUSTRIES_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(INDUSTRIES_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(INDUSTRIES_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    });
});

export default industriesReducer;
